var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scale-slider"},[_c('slider',{attrs:{"type":"range","value":_vm.objectScale,"min":0.1,"max":10,"step":"0.1","empty-rail":"#F4F4F4","filled-rail":"#6FD6BD"},on:{"input":function($event){return _vm.scaleObject($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }